const autoMappings = {
  lossDate: ['lossDate'],
  lineOfBusiness: ['claim_type'],
  lossScenario: ['lossCause'],
  secLossScenario: ['secLossScenario'],
  abOnlyLossScenario: ['abOnlyLossScenario'],
  digitalFNOLStatus: ['digitalFNOLStatus'],
  description: ['description'],
  numberOfVehiclesInvolved: ['vehiclesInvolved'],
  hitObject: ['hitObject'],
  tpVehicleInjury: ['applyThirdParty'],
  tpPedestrianInjury: ['tpPedestrianInjury'],
  tpCyclistInjury: ['tpCyclistInjury'],
  windshieldOnlyDamaged: ['windshieldDamaged'],
  vehicleRecovered: ['wasVehicleFound'],
  rentalType: ['services', 'rentalType'],

  // animals object
  'animal.animalType': ['animalTypeHit'],
  'animal.ownerContacted': ['ownerContactInformation'],
  'animal.owner.firstName': [
    'owner',
    'firstName',
  ],
  'animal.owner.lastName': [
    'owner',
    'lastName',
  ],
  'animal.owner.phoneNumber': [
    'owner',
    'phoneNumber',
  ],
  'animal.owner.emailAddress': [
    'owner',
    'emailAddress',
  ],

  notes: ['notes'],
  officials: ['officials'],
  contact: ['contact'],
  injuryIncident: ['injuredInjuries'],
  vehicleIncident: ['vehicleIncident'],
  lossLocation: ['lossLocation'],
};

module.exports = {
  autoMappings,
};
